import * as attachments from '../../../../../constants/attachments';

/**
 * Created by AAKondratov on 19.03.2018.
 */

export const acceptExtensions = attachments.DEFAULT_EXTENSIONS;

export async function saveFile(fileObject) {
  const { default: iconv } = await import('pika-iconv-lite/lib');
  const { default: fileSaver } = await import('file-saver');

  const byteArrayWin1251 = iconv.encode(fileObject.xml, 'win1251');
  const blob = new Blob([byteArrayWin1251], { type: 'application/xml;charset=windows-1251' });

  fileSaver.saveAs(blob, `${fileObject.fileName}`, true);
}
